import type { FC } from "react";

import { useSelector } from "react-redux";

import type { IPlainTooltipProps } from "@similarweb/ui-components";

import type { TableActionProps } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import { WEBSITE_ASSIGN_TO_USER_MODAL_TITLE } from "app/pages/sales-intelligence/modules/leads-search";
import { AssignToUserModal, selectIsShowAssignToUserModal } from "app/pages/sales-intelligence/sub-modules/assign-to-users";
import AssignToOtherUsersButtonBaseContainer from "app/pages/sales-intelligence/sub-modules/assign-to-users/containers/AssignToOtherUsersButton/AssignToOtherUsersButtonBaseContainer";

type AssignToUserCompetitiveButtonProps = {
    onClick: () => void;
    tooltipContent?: IPlainTooltipProps["tooltipContent"];
} & TableActionProps;

const AssignToUserCompetitiveButton: FC<AssignToUserCompetitiveButtonProps> = ({
    isDisabled = false,
    tooltipContent,
    onClick,
}) => {
    const isShowAssignToUserModal = useSelector(selectIsShowAssignToUserModal);

    return (
        <>
            <AssignToUserModal
                isOpen={isShowAssignToUserModal}
                titleTranslatable={WEBSITE_ASSIGN_TO_USER_MODAL_TITLE}
            />
            <AssignToOtherUsersButtonBaseContainer
                isDisabled={isDisabled}
                tooltipContent={tooltipContent}
                onClick={onClick}
            />
        </>
    );
};

export default AssignToUserCompetitiveButton;
